import React, { forwardRef, useCallback } from 'react'
import { Grid, Checkbox, CheckboxGroup } from '@chakra-ui/react'

export const FormAnswerMultiple = forwardRef(
  (
    {
      value,
      onChange,
      options,
      notApplicable,
      isInvalid,
      isRequired,
      isReadOnly,
      isDisabled,
      ...props
    },
    ref
  ) => {
    const handleChange = useCallback(
      value =>
        onChange?.({
          type: 'options',
          options: value === 'n/a' ? null : value?.map(id => ({ id: parseInt(id) })),
          notApplicable: notApplicable && value.includes('n/a')
        }),
      [onChange, notApplicable]
    )

    const checkboxValue = value
      ? value.notApplicable
        ? ['n/a']
        : value?.options.map(v => `${v.id}`)
      : []

    return (
      <CheckboxGroup {...props} value={checkboxValue} onChange={handleChange}>
        <Grid templateColumns='1fr 1fr'>
          {options.map(({ id, value }, index) => (
            <Checkbox
              key={index}
              value={`${id}`}
              isInvalid={isInvalid}
              isReadOnly={isReadOnly}
              isDisabled={isDisabled || checkboxValue?.includes('n/a')}>
              {value}
            </Checkbox>
          ))}
          {notApplicable && (
            <Checkbox
              value='n/a'
              isInvalid={isInvalid}
              isReadOnly={isReadOnly}
              isDisabled={isDisabled}>
              N/A
            </Checkbox>
          )}
        </Grid>
      </CheckboxGroup>
    )
  }
)

export default FormAnswerMultiple
